import Header from './Header';
import Footer from './Footer';

import { ILayoutProps } from './default';

const LandLayout: React.FC<ILayoutProps> = ({ children, isAuth }) => {
    return (
        <div className="flex flex-col min-h-[100vh] bg-blueGray-100">
            <Header isAuth={isAuth} />
            <div>{children}</div>
            <Footer isAuth={isAuth} />
        </div>
    );
};

export default LandLayout;
